@if (!erreurRecuperation()) {
  <div class="mes-projects">
    <app-liste-generique [proprietesAffichees]="proprietesAfficheesProjets()" [listeObjets]="tabProjets()"
      [filtreParDefaut]="{'prop':'estTermine','val':'false','type':'boolean'}" (clicObjetEvent)="ouvrirProjet($event)"
    [triParDefaut]="{'prop':'nom', 'type':'string'}" [listeModifiee]="listeModifiee"></app-liste-generique>
    <div class="footer">
      <button *showIfHasRole="'create_project'" class="btn btn-primary" (click)="ouvrirModaleAjout()"
        style="margin-right:10px;">
        <i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="lancerExport()" style="margin-right:10px;">
        <i class="fas fa-file-export" style="padding-right:5px"></i>{{'MON_SITE.EXPORTER_DONNEE_ANALYSE' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="openModalReports(modReports)">
        <i class="fas fa-file-excel" style="padding-right:5px"></i>{{'MON_SITE.REPORTS' | translate}}
      </button>
    </div>
    <div class="modal fade" bsModal #modalNoWorkflow="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
      aria-labelledby="dialog-static-name">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left">{{'GLOBAL.PROJET' | translate}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalNoWorkflow.hide()"
              title="{{'GLOBAL.FERMER' | translate}}">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="not-selectable">{{'MES_PROJETS.MESSAGE_NO_WORKFLOW' | translate}}</p>
            <div class="btn-toolbar justify-content-end">
              <button type="button" class="btn btn-secondary"
              (click)="modalNoWorkflow.hide()">{{'GLOBAL.FERMER' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div bsModal #modalExport="bs-modal" class="modal fade" tabindex="-1"
      aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left not-selectable">{{'GLOBAL.EXPORT_DONNEES' | translate}}</h4>
          </div>
          <div class="modal-body">
            <div class="not-selectable" [ngClass]="aucuneDonnee() ? '' :'text-center'">
              {{aucuneDonnee() ? ('GLOBAL.AUCUNE_DONNEE_EXPORT' | translate) : ('GLOBAL.PREPARATION_EXPORT' | translate)}}
            </div>
            @if (aucuneDonnee()) {
              <div class="btn-toolbar justify-content-end">
                <button type="button" class="btn btn-secondary"
                (click)="modalExport.hide()">{{'GLOBAL.FERMER' | translate}}</button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}

<ng-template #modReports>
  <div class="modal-header">
    @if (selectedReport()?.type === ReportType.DELIVERIESLOG) {
      <h4 class="modal-title pull-left">{{'DELIVERIES.DELIVERIES_REPORTS' | translate }}</h4>
    }
    @if (selectedReport()?.type === ReportType.FEEDBACK) {
      <h4 class="modal-title pull-left">{{'RAPPORT_TIR.FEEDBACK_REPORT' | translate }}</h4>
    }
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalReports().hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="modal-content">

      <div class="modal-content-item">
        <label for="date">{{'RAPPORT_TIR.SELECT_REPORT'| translate }} </label>
        <ng-select name="selectReport" id="selectReport" [items]="reportTemplates()" bindLabel="name"
          [(ngModel)]="selectedReport" (ngModelChange)="onReportTypeChange($event)" [addTag]="true" [hideSelected]="false" [multiple]="false" [closeOnSelect]="true">
        </ng-select>
        @if (!selectedReport()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}
          </div>
        }
      </div>

      <div class="form-group mb-1">
        <label for="tabProjets">{{'GLOBAL.PROJETS'| translate }} </label>
        <ng-select #projects (change)="onChangeProjects($event)" class="custom" [items]="tabProjets()" [multiple]="true"
          placeholder="{{'GLOBAL.PROJETS' | translate}}" [ngModel]="tabProjetsSelected()" [disabled]="false"
          [clearable]="false" name="tabProjets" bindLabel="nom">
        </ng-select>
      </div>

      <div class="row">
        <div class="col-md-8">
          <div class="form-group mb-1">
            <label for="startDate">{{ 'DELIVERY.START_DATE' | translate }}</label>
            <div class="input-group">
              <input placeholder="{{ 'DELIVERY.START_DATE' | translate }}" autocomplete="off" type="text"
                class="form-control" [matDatepicker]="startDatePicker"
                (dateChange)="onDateTimeChange($event.value, 'start_date')" [(ngModel)]="startDate" name="startDate"
                (click)="startDatePicker.open()" (focus)="startDatePicker.open()" readonly />
              
              <mat-datepicker #startDatePicker></mat-datepicker>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-1">
              <label for="startTime">{{ 'DELIVERY.START_TIME' | translate }}</label>
              <app-custom-select
                [options]="startTimeOptions()"
                [placeholder]="'Hour'"
                [(ngModel)]="startTime"
                (selectionChange)="onDateTimeChange()"
                name="startTime">
              </app-custom-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group mb-1">
              <label for="endDate">{{ 'DELIVERY.END_DATE' | translate }}</label>
              <div class="input-group">
                <input placeholder="{{ 'DELIVERY.END_DATE' | translate }}" autocomplete="off" type="text"
                  class="form-control" [matDatepicker]="endDatePicker"
                  (dateChange)="onDateTimeChange($event.value, 'end_date')" [(ngModel)]="endDate" name="endDate"
                  (click)="endDatePicker.open()" (focus)="endDatePicker.open()" readonly />
                
                <mat-datepicker #endDatePicker></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="endTime">{{ 'DELIVERY.END_TIME' | translate }}</label>
                <app-custom-select
                  [options]="endTimeOptions()"
                  [placeholder]="'Hour'"
                  [(ngModel)]="endTime"
                  (selectionChange)="onDateTimeChange()"
                  name="endTime">
                </app-custom-select>
              </div>
            </div>
          </div>

          @if (!invalideDate()) {
            <div class="row mt-2">
              <div class="col-md-12">
                @if (duration()) {
                  <div class="alert alert-info">
                    {{'GLOBAL.DURATION' | translate}} : {{ duration() }}
                  </div>
                }
              </div>
            </div>
          }

          @if (invalideDate()) {
            <div class="row mt-2">
              <div class="col-md-12">
                @if (duration()) {
                  <div class="alert alert-danger">
                    {{duration()| translate}}
                  </div>
                }
              </div>
            </div>
          }

          @if (selectedReport()?.type === ReportType.DELIVERIESLOG) {
            <div class="form-group mb-2">
              <label for="deliveriesDates">{{'DELIVERIES.DELIVERIES' | translate}}</label>
              <ng-select #delivery class="custom" [items]="deliveriesDates()" [multiple]="true"
                placeholder="{{'DELIVERIES.DELIVERIES' | translate}}" [(ngModel)]="deliveriesDates" [disabled]="false"
                [clearable]="false" name="deliveriesDates" bindLabel="startTimeFormatted" >
              </ng-select>
            </div>
          }

          @if (selectedReport()?.type === ReportType.FEEDBACK) {
            <div class="form-group mb-2">
              <label for="tirsBySurveyAnswerFiltered">{{'RAPPORT_TIR.FEEDBACK' | translate}}</label>
              <ng-select #feedback class="custom" [items]="tirsBySurveyAnswerFiltered()" [multiple]="true"
                placeholder="{{'GLOBAL.TIR' | translate}}" [(ngModel)]="tirsBySurveyAnswerFiltered" [disabled]="false"
                [clearable]="false" name="tirsBySurveyAnswerFiltered" bindLabel="tirsName" >
              </ng-select>
            </div>
          }


          @if (selectedReport()?.type === ReportType.DELIVERIESLOG) {
            <div class="form-group mb-1 resume">
              <div class="input-group resume-item">
                <input placeholder="Resume" autocomplete="off" type="checkbox" class="resume-item" name="resume"
                  [(ngModel)]="isResume" />
                  <label for="resume">Resume</label>
                </div>
              </div>
            }


          </div>

        </div>
        <div class="modal-footer">
          <div>
            <button class="btn btn-outline-success pull-left" style="margin-right:10px;" type="submit"
            (click)="downloadRepports()">{{'DELIVERIES.DOWNLOAD' | translate}}</button>
          </div>
          <button type="button" class="btn btn-secondary"
          (click)="modalReports().hide()">{{'GLOBAL.FERMER' | translate}}</button>
        </div>


      </ng-template>